import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-transparent py-16" data-id="element-146">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-147">
        <div className="bg-[#1A1A1A] p-8 md:p-12 rounded-lg border border-[#D4A843]/50" data-id="element-148">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-149">
            <ShieldCheckIcon className="w-12 h-12 text-[#D4A843]" data-id="element-150" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-151">
              Garantía{' '}
              <span className="tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#CAB072]" data-id="element-152">
                SaludEnTuPlato™
              </span>{' '}
              7 Días
            </h2>
          </div>
          <div className="text-center space-y-4" data-id="element-153">
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-154">
              Descargá el MegaPack, revisalo, usalo en tu sala. Si en los
              próximos 7 días sentís que no es lo que esperabas, escribinos y te
              devolvemos el 100% de tu dinero.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-155">
              Sin preguntas. Sin vueltas. Sin letra chica.
            </p>
            <p className="text-xl font-semibold text-[#D4A843]" data-id="element-156">
              El riesgo es nuestro, no tuyo.
            </p>
          </div>
        </div>
        <p className="text-xs text-gray-500 text-center mt-4 leading-relaxed" data-id="element-157">
          La confianza que tenemos en el MegaPack Psicopedagogía nos permite
          hacer esa promesa sin dudar. Más de 300 profesionales de todo el país
          ya lo saben. La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}